import * as tslib_1 from "tslib";
import { Vue, Component, Prop } from "vue-property-decorator";
var KkGenericPopup = /** @class */ (function (_super) {
    tslib_1.__extends(KkGenericPopup, _super);
    function KkGenericPopup() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    KkGenericPopup.prototype.close = function () {
        this.$emit('close');
    };
    tslib_1.__decorate([
        Prop(),
        tslib_1.__metadata("design:type", String)
    ], KkGenericPopup.prototype, "title", void 0);
    tslib_1.__decorate([
        Prop({ default: false }),
        tslib_1.__metadata("design:type", Boolean)
    ], KkGenericPopup.prototype, "visible", void 0);
    KkGenericPopup = tslib_1.__decorate([
        Component
    ], KkGenericPopup);
    return KkGenericPopup;
}(Vue));
export default KkGenericPopup;
Vue.component("kk-generic-popup", KkGenericPopup);



//////////////////
// WEBPACK FOOTER
// ./~/ts-loader!./~/vue-loader/lib/selector.js?type=script&index=0!./app/ts/components/KkGenericPopup.vue
// module id = 49
// module chunks = 0